import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface MutedProps extends HTMLAttributes<HTMLParagraphElement> {}

const Muted = forwardRef<HTMLParagraphElement, MutedProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <p
        ref={ref}
        className={cn('text-sm text-muted-foreground', className)}
        {...props}
      >
        {children}
      </p>
    );
  }
);

Muted.displayName = 'Muted';

export { Muted };
